import { igApi } from '../../api';

export const onWidgetDeletion = async (editorSDKUtils, flowAPI) => {
  const noWidgetsLeft = await isLastWidget(editorSDKUtils);
  if (noWidgetsLeft) {
    await disconnectAllAccounts(flowAPI);
  }
};

const isLastWidget = async (editorSDKUtils): Promise<boolean> => {
  const allRefs = await editorSDKUtils.getAllAppRefComponents();
  return !allRefs?.length;
};

const disconnectAllAccounts = async (flowAPI) => {
  if (!flowAPI) {
    return;
  }
  const { instagramAccounts } = await igApi(flowAPI).getAllAccounts();
  if (instagramAccounts?.length) {
    instagramAccounts.forEach((account) => {
      igApi(flowAPI).disconnect(account.id as string);
    });
  }
};
